import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const StyledModal = styled(Modal)`
  & > div {
    width: 650px;
    max-height: calc(100vh - 100px);
  }
`

export const Text = styled.p``

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.grayDark};
  margin-bottom: 16px;
`
